export default __webpack_public_path__ + "img/tope.c93e1ed1.jpeg";